var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"portable-text",class:{
    'portable-text--medium': _vm.medium,
    'portable-text--light': _vm.light,
  },domProps:{"innerHTML":_vm._s(_vm.render)}})
}
var staticRenderFns = []

export { render, staticRenderFns }